export const daysConstant = [
	{ text: "1 Day in advance", value: 1 },
	{ text: "2 Days in advance", value: 2 },
	{ text: "3 Days in advance", value: 3 },
	{ text: "4 Days in advance", value: 4 },
	{ text: "5 Days in advance", value: 5 },
];

export const tenderUserTypeIds = {
	customer: 1,
	internal: 2,
	vendor: 3,
} as const;

export type TenderUserTypeId =
	(typeof tenderUserTypeIds)[keyof typeof tenderUserTypeIds];

export const tenderUserTypeNames: Record<TenderUserTypeId, string> = {
	[tenderUserTypeIds.customer]: "Customer",
	[tenderUserTypeIds.internal]: "Internal/AR",
	[tenderUserTypeIds.vendor]: "Vendor",
};
